var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"header":"Importações"}},[_c('Grid',{ref:"filterGridImports",attrs:{"name":"filterGridImports","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3f14eb0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/tables/imports.vue
// module id = 996
// module chunks = 1